module.exports = __webpack_public_path__ + "img/triangle-jaune.0031eaac.png";